module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_78.75deg.85a5b964.png";